import React from "react";
import "./AboutUs.css";
const AboutUs = () => {
  return (
    <>
      <div className="AboutUs--FirstDiv">
        <h2>EVERYTHING YOU NEED TO KNOW ABOUT</h2>
      </div>
      <div className="AboutUs-Container">
        <div className="AboutUs--DigitalImpacts">
          <h2>THE DIGITAL IMPACTS</h2>
        </div>
        <div className="AboutUs--DigitalImpacts">
          <p>
            The <b>Digital Impacts</b> create a perfect company for its
            customers.
            <b> Digital Impacts</b> offers the best services to ensure your
            business thrives online. Because we partner with our clients with a
            team of professionals, we can to provide the best on our side.
            We strive to be leaders in digital marketing services worldwide by
            revolutionizing the industry and setting new standards of
            professionalism and success.
          </p>
        </div>
        <div className="AboutUs--DigitalImpacts">
          <h2>OUR VISION</h2>
        </div>
        <div className="AboutUs--DigitalImpacts">
          <p>
            We strive to be leaders in digital marketing services across the
            world by revolutionizing the industry and setting new standards of
            professionalism and success. Our vision is to become a top agency
            offering online marketing strategies, digital sales solutions, and
            internet brand management in the international business sphere.
          </p>
        </div>
        <div className="AboutUs--DigitalImpacts">
          <h2>OUR MISSION</h2>
        </div>
        <div className="AboutUs--DigitalImpacts">
          <p>
            Our mission is to partner with customers for their success as we
            create diverse client base including companies and individuals
            functioning in many different fields and economies. We will be best
            in providing consistently successful, unique, and forward-thinking
            digital marketing solutions that take into account the individual
            requirements and unique demands of each client.
          </p>
        </div>
      </div>
      <div className="AboutUs---3-div---Container">
        <div className="AboutUs---3-1div">
          <h1 className="AboutUs---3-1div-h1">10000+</h1>
          <h2 className="AboutUs---3-1div-h2">Domain Names Registered</h2>
        </div>
        <div className="AboutUs---3-2div">
          <h1 className="AboutUs---3-1div-h1">90000+</h1>
          <h2 className="AboutUs---3-1div-h2">Websites Hosted</h2>
        </div>
        <div className="AboutUs---3-3div">
          <h1 className="AboutUs---3-3div-h1">45000+</h1>
          <h2 className="AboutUs---3-3div-h2">Customers</h2>
        </div>
      </div>
    </>
  );
};

export default AboutUs;
